import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api.ts';

// 2026-08-23: retry 原本是 false —— 那對**業務錯誤**是對的 (400 驗證 / 403 權限 /
// 404 重試一百次也一樣, 只會讓紅框慢三倍才出現)。 但它把**連線類**錯誤也一起擋掉了:
// 前端 nginx 連後端偶發卡在 TLS handshake → 504, 使用者看到紅框、只能自己重新整理。
//
// 改成有節制的重試: 只重試「再試一次可能就好」的那種 —— 網路層失敗 (fetch reject,
// 沒有 status) 與 502/503/504 (閘道連不到後端)。 其餘一律不重試, 維持原本的意圖。
// 搭配 nginx 的 proxy_connect_timeout 10s: 卡住的請求 10 秒內失敗 → 自動重試 →
// 使用者多半根本不會看到錯誤。
const RETRYABLE_STATUS = new Set([502, 503, 504]);
function isRetryable(error: unknown): boolean {
  // fetch 本身失敗 (斷網 / TLS 失敗) → 不是 ApiError, 沒有 status
  if (!(error instanceof ApiError)) return true;
  return RETRYABLE_STATUS.has(error.status);
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => failureCount < 2 && isRetryable(error),
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});
